import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMultipleUsers1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "multiple-users-1" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 11.5,
			cy: 4.125,
			r: 3.375
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M15.553,10.5a6.028,6.028,0,0,0-8.106,0"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M14.875,4.236A6.752,6.752,0,0,1,13,4.5,6.723,6.723,0,0,1,8.432,2.719"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 18.5,
			cy: 16.125,
			r: 3.375
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M23.25,23.25a6.026,6.026,0,0,0-9.5,0"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M21.875,16.236a6.76,6.76,0,0,1-6.443-1.517"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 5.5,
			cy: 16.125,
			r: 3.375
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M10.249,23.25a6.026,6.026,0,0,0-9.5,0"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M8.875,16.236a6.76,6.76,0,0,1-6.443-1.517"
		})
	]
});
export default SvgMultipleUsers1;
